import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-ai-chat-settings-skeleton',
  templateUrl: './ai-chat-settings-skeleton.component.html',
  styleUrls: ['./ai-chat-settings-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class AiChatSettingsSkeletonComponent {
  readonly summaryRows = [1, 2, 3, 4, 5, 6];
  readonly formRows = [1, 2, 3, 4];
}